import {useEffect, useState} from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { TSPage } from '../components/commons';

import './BitDetailsPage.scss';

const BitDetailsPage = function ({ name, onBack, data, btn }) {
    const [state, dispatcher] = useApp();
    const [stateDetails, setStateDetails] = useState({
        ...data?.["claim.policyDetails"],
        customerPhone: data?.["claim.policyDetails"]?.customerPhone?.replace("+972", "0")
    });
    const [stateErrors, setStateErrors] = useState({});
    const [stateBusy, setStateBusy] = useState(false);
    const [stateSelectedOtherPerson, setStateSelectedOtherPerson] = useState(false);
    const [stateDisabled, setStateDisabled] = useState({});

    useEffect(() => {
        let disabled = {};
        if (!stateSelectedOtherPerson) {
            ["customerFirstName", "customerLastName", "customerPhone", "customerPId"].forEach(key => {
                if (data?.["claim.policyDetails"][key])
                    disabled[key] = true;
            })
        }
        setStateDisabled(disabled);
    }, [stateSelectedOtherPerson]);

    const handleSelectOtherPerson = (e) => {
        let sd = { ...stateDetails, otherPerson: !stateSelectedOtherPerson };
        if (sd.otherPerson) {
            sd = {...sd, customerFirstName: "", customerLastName: "", customerPhone: "", customerPId: ""};
        } else {
            sd = {
                ...data?.["claim.policyDetails"],
                customerPhone: data?.["claim.policyDetails"]?.customerPhone?.replace("+972", "0"),
                otherPerson: false
            };
        }
        setStateDetails(sd);
        setStateSelectedOtherPerson(!stateSelectedOtherPerson);
        setStateErrors({});
    }

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (stateBusy) return;

        if (!validateFields()) {
            return;
        }

        let answer = {
            display: "התקבלו פרטי חשבון ביט",
            value: stateDetails,
            id: btn?.id,
            field: btn?.field
        }

        setStateBusy(true);
        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'bitAccount' });
            })
            .catch(ex => {
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    const validateFields = function () {
        var errors = {};
        if (!stateDetails.customerFirstName)
            errors.customerFirstName = "יש להזין שם פרטי";

        if (!stateDetails.customerLastName)
            errors.customerLastName = "יש להזין שם משפחה";

        if (!stateDetails.customerPhone)
            errors.customerPhone = "יש להזין את מספר הטלפון";

        if (!stateDetails.customerPId)
            errors.bitcustomerPId = "יש להזין את מספר תעודת הזיהוי";

        setStateErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const onFieldChange = function (id, e) {
        const cs = { ...stateDetails };
        cs[id] = e.target.value;
        setStateDetails(cs);
    }

    const cb = (_inview, ioe) => { ioe.target.querySelector(".container").classList.add("on"); }

    data = data || {};

    return (
        <TSPage name={name}>
            <Slide direction="up" duration="500" onVisibilityChange={cb}>
                <div className="container on">
                    <div className="header">
                        <button className="btn right" onClick={handleBack}>
                            <img src="img/right-arrow.svg" alt="back" />
                        </button>
                        <div className="title">
                            פרטי חשבון ביט להעברת התשלום
                        </div>
                    </div>
                    <div className="content" style={{ marginLeft: -state?.uiParams?.scrollSize?.w + "px" }}>
                        <div className="top">
                            <form onSubmit={handleSubmit}>
                                <h5>יש לאשר את פרטי חשבון הביט של בעל הפוליסה בלבד</h5>
                                <div key="otherPersonSelect" className={"otherPerson" + (stateSelectedOtherPerson ? " selected" : "")} onClick={handleSelectOtherPerson}>
                                    <div className="selector"><img src={"img/circle-selector-" + (stateSelectedOtherPerson ? "full-white" : "empty") + ".svg"} alt="" /></div>
                                    <div className="txt">אני בכל זאת רוצה שהתשלום יגיע לאדם אחר</div>
                                </div>
                                {stateSelectedOtherPerson ?
                                <div id="otherPersonAdded" className="otherPersonAdded">
                                    <div className="txt">אם התביעה תאושר ובהתאם להנחיית משרד האוצר, ההחזר הכספי צריך להיעשות לבעל הפוליסה בלבד. למרות זאת, אנחנו יכולים לבצע את התשלום לאדם אחר. במקרה זה, נבקש לבצע את השלבים הבאים:</div>
                                    <ol>
                                        <li>יש ללחוץ על הכפתור למטה ולהוריד את טופס המחאת הזכות, ואז  להדפיס ולמלא אותו. ניתן לפנות לשירות הלקוחות שלנו בכל שאלה.</li>
                                        <a href="https://assets.chayuta.com/shomera/payer-transfer-rights.pdf" download="Proposed_Filename" target="_blank">
                                            <img src="img/button-download.svg" alt="Download Icon" />
                                        </a>
                                        <li>יש לחתום עליו בכתב ידך ולאמת אותו על ידי עורך דין.</li>
                                        <li>יש לסרוק את הטופס החתום ולצרפו בהמשך במסך העלאת מסמכים.</li>
                                    </ol>
                                    <div className='txtBold'> לתשומת לבך <span className="redHeart">❤</span></div>
                                    <div className="info">
                                        <div className="img"><img src="img/info.svg" alt="" /></div>
                                        <div className='txt'>אי אפשר להשלים את תהליך הגשת התביעה בלי המחאת זכות חתומה ומאומתת.</div>
                                    </div>
                                </div>
                                : undefined }
                                    <div className={"row double"}>
                                    <div className="part">
                                        <label>שם פרטי</label>
                                        <input type="text" name="customerFirstName" value={stateDetails.customerFirstName} onChange={onFieldChange.bind(this, "customerFirstName")} className={stateErrors.customerFirstName && "error"} disabled={stateDisabled.customerFirstName}></input>
                                        <div className={"validationError " + (stateErrors.customerFirstName && "on")}>{stateErrors.customerFirstName}</div>
                                    </div>
                                    <div className="part">
                                        <label>שם משפחה</label>
                                        <input type="text" name="customerLastName" value={stateDetails.customerLastName} onChange={onFieldChange.bind(this, "customerLastName")} className={stateErrors.customerLastName && "error"} disabled={stateDisabled.customerLastName}></input>
                                        <div className={"validationError " + (stateErrors.customerLastName && "on")}>{stateErrors.customerLastName}</div>
                                    </div>
                                </div>
                                <div className={"row double"}>
                                    <div className="part single">
                                        <label>מספר טלפון</label>
                                        <input type="tel" name="customerPhone" value={stateDetails.customerPhone} onChange={onFieldChange.bind(this, "customerPhone")} className={stateErrors.customerPhone && "error"} disabled={stateDisabled.customerPhone}></input>
                                        <div className={"validationError " + (stateErrors.customerPhone && "on")}>{stateErrors.customerPhone}</div>
                                    </div>
                                </div>
                                <div className={"row double"}>
                                    <div className="part single">
                                        <label>מספר ת"ז</label>
                                        <input type="number" name="bitPid" value={stateDetails.customerPId} onChange={onFieldChange.bind(this, "customerPId")} className={stateErrors.customerPId && "error"} disabled={stateDisabled.customerPId}></input>
                                        <div className={"validationError " + (stateErrors.customerPId && "on")}>{stateErrors.customerPId}</div>
                                    </div>
                                </div>
                                <div className='txtBold'> לתשומת לבך <span className="redHeart">❤</span></div>
                                <div className="info">
                                    <div className="img"><img src="img/info.svg" alt="" /></div>
                                    <div className='txt'>יש לוודא שמספר הטלפון תואם את מספר ת"ז איתו נרשמתם לחשבון הביט.</div>
                                </div>
                                <div className="info">
                                    <div className="img"><img src="img/info.svg" alt="" /></div>
                                    <div className='txt'>אם התביעה תאושר, תקבלו העברה מ"שומרה חברה לביטוח".</div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="blueLine"></div>
                    <div className="dialog-buttons">
                        <button className="orange" onClick={handleSubmit}>אישור</button>
                        <button onClick={handleBack}>ביטול</button>
                    </div>
                </div>
            </Slide >
        </TSPage >
    );
}

export { BitDetailsPage }